/**
 * Sentry for React Configuration
 * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/}
 */

import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";

const { VITE_SENTRY_DSN, PROD: isProduction, MODE: viteMode } = import.meta.env;

type InitSentryOptions = {
  enabled?: boolean;
};

const initSentry = (options?: InitSentryOptions) => {
  if (options?.enabled === false) return;

  const commonConfig = {
    dsn: VITE_SENTRY_DSN, // Data Source Name
    environment: viteMode,
    // 設定 release 版本，讓錯誤可以對應到正確的 source maps
    release: __RELEASE_VERSION__,
    // 自動記錄使用者 IP 位址、user agent 等 (Pii：個資)
    sendDefaultPii: true,
  };

  const productionConfig = {
    integrations: [
      // 收集載入效能資料（例如首屏渲染時間、route change 耗時、API latency）
      Sentry.browserTracingIntegration(),
      // 啟用 Session Replay（重播使用者操作畫面）
      Sentry.replayIntegration(),
      // new BrowserTracing(),
    ],
    // 追蹤的樣本率 (未來 Prod 調低至 0.2)
    tracesSampleRate: 0.5,
    // 追蹤指定的 URL 的 API 請求效能
    tracePropagationTargets: [/^https:\/\/shop\.yunacoffee\.tw\/api/],
    // 隨機錄下部分使用者互動過程 (未來 Prod 調低至 0.2)
    replaysSessionSampleRate: 0.3,
    // 若上面設定為未全錄，1.0 代表只要出錯，就一定會保留影片重播
    replaysOnErrorSampleRate: 1.0,
    // 在 console 顯示 Sentry 自身的 debug log
    enableLogs: false,
  };

  const developmentConfig = {
    integrations: [],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/dev-shop\.yunacoffee\.tw\/api/],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  };

  Sentry.init({
    ...commonConfig,
    ...(isProduction ? productionConfig : developmentConfig),
  });
};

export default initSentry;
